import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator } from '@angular/material/legacy-paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationService } from 'projects/zbs-app/src/app/components/configuration-select/configuration.service';
import { Configuration } from 'projects/zbs-app/src/app/services/Ebootis.Queries/Configuration';
import { OrdersOfLogonUser } from 'projects/zbs-app/src/app/services/Ebootis.Queries/OrdersOfLogonUser';
import { Subject, takeUntil } from 'rxjs';
import { OrderTableI18n } from './OrderTableI18n';

export interface OrderTableData {
	orders: OrdersOfLogonUser.Result[];
	/**
	 * wenn true, wird aus der Spalte 'Status' die Spalte 'Sendungsnr.'
	 */
	hasTrackingnos: boolean;
}

@Component({
	selector: 'app-order-table',
	templateUrl: './order-table.component.html',
	styleUrls: ['./order-table.component.scss'],
	providers: [OrderTableI18n]
})
export class OrderTableComponent implements OnInit, OnDestroy {

	@Input() set setTable(p_value: OrderTableData) {
		this.m_queryData = p_value?.orders;
		this.m_hasTrackingnos = p_value?.hasTrackingnos ?? false;
		this.initAndReinitTable();
	}

	@Input() set orderTableTitle(p_value: string) {
		if (p_value) {
			this.m_titleText = p_value;
		}
	}

	@Output() public orderSelect: EventEmitter<string> = new EventEmitter();

	@Output() public sortAttributeChanged: EventEmitter<string> = new EventEmitter();

	@ViewChild(MatLegacyPaginator) set matPaginator(p_paginator: MatLegacyPaginator) {
		this.m_dataSource.paginator = p_paginator;
	}
	@ViewChild(MatSort, { static: true }) set matSort(p_sort: MatSort) {
		this.m_dataSource.sort = p_sort;
	}

	/**
	 * wenn true, wird aus der Spalte 'Status' die Spalte 'Sendungsnr.'
	 */
	private m_hasTrackingnos: boolean = false;
	private readonly TRACKINGNO_COLUMN = 'trackingNo';
	private readonly DELIVERY_STATE_COLUMN = 'deliveryState';
	private readonly ZBS_VALUE_LIST_ENTRY = 'zbsValuelistEntry';
	private m_titleText: string = '';
	private m_subscriptionsSubject = new Subject();
	public m_queryData: OrdersOfLogonUser.Result[];
	public m_dataSource: MatTableDataSource<OrdersOfLogonUser.Result>;
	public m_displayedColumns: string[] = ['creationDate', 'id', 'location', this.DELIVERY_STATE_COLUMN, 'alternateName', this.ZBS_VALUE_LIST_ENTRY, /*'trackingNo',*/ 'orderValue', 'freightageSurcharge', 'tool'];
	public m_zbsConfig: Configuration.Result;

	get TableTitle(): string {
		return this.m_titleText;
	}

	constructor(
		private m_changeDetectorRef: ChangeDetectorRef,
		private m_translation: OrderTableI18n,
		private cfgService: ConfigurationService,
	) {
		this.cfgService.getConfiguration().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
			next: (p_result) => {
				this.m_zbsConfig = p_result;

				this.initAndReinitTable();
			}
		});
		this.m_dataSource = new MatTableDataSource<OrdersOfLogonUser.Result>();
	}

	/**
	 * Titel der Tabelle wird gesetzt.
	 */
	public ngOnInit(): void {
		if (this.m_titleText == '') {
			this.m_titleText = this.m_translation.orderTableTitleText;
		}
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Eine Customer OID wird an das übergeordnete Component übergeben um den Customer in der Detailansicht zu laden.
	 * @param p_element Order OID
	 */
	public orderDetails_Click(p_element): void {
		this.orderSelect.emit(p_element.oid);
	}

	/**
	 * Die Tabelle wird initialisiert oder reinitialisiert.
	 */
	public initAndReinitTable(): void {

		if (this.m_hasTrackingnos) {
			const idx = this.m_displayedColumns.indexOf(this.DELIVERY_STATE_COLUMN);
			this.m_displayedColumns[idx] = this.TRACKINGNO_COLUMN;
		} else {
			const idx = this.m_displayedColumns.indexOf(this.TRACKINGNO_COLUMN);
			this.m_displayedColumns[idx] = this.DELIVERY_STATE_COLUMN;
		}

		if (!this.m_zbsConfig.valuelistEnabled) {
			const idx = this.m_displayedColumns.indexOf(this.ZBS_VALUE_LIST_ENTRY);
			if (idx != -1) {
				this.m_displayedColumns.splice(idx, 1);
			}
		}

		this.m_dataSource.data = this.m_queryData;
		if (this.m_dataSource.paginator) {
			this.m_dataSource.paginator.firstPage();
		}
		this.m_changeDetectorRef.detectChanges();
	}

	public sortingChanged(p_event: Sort) {
		if (this.m_dataSource.paginator) {
			this.m_dataSource.paginator.firstPage();
		}
		this.sortAttributeChanged.emit(p_event.active + ' ' + p_event.direction);
	}

}
